import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { EmptyState } from "@shared/common/components/State/EmptyState";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";
import { useLocalStorageManager } from "@shared/common/hooks/useLocalStorageManager";
import { useQueries } from "@tanstack/react-query";
import React from "react";
import { KlussenOverview } from "./KlussenOverview";

export function KlussenOverviewWrapper(): React.JSX.Element {
  const isKnopLoading = useKnopIsLoading((state) => state.isLoading);
  const { knopClient } = useKnopClient();
  const { prepareStore } = useLocalStorageManager();
  const { instanceId } = useCurrentInstanceId();
  const queries = useQueries({
    queries: [
      {
        queryKey: instances.current(instanceId).scenario,
        queryFn: () => knopClient.getScenario(instanceId),
      },
    ],
  });

  if (isKnopLoading || queries.some((q) => q.isLoading))
    return (
      <div data-testid="state-klussen-loading">
        <LoadingState fullPage={false} />
      </div>
    );

  if (queries.some((q) => q.isError)) {
    queries.filter((q) => q.isError).forEach((q) => console.log(q.error));
    return (
      <div data-testid="state-klussen-error">
        <ErrorState />
      </div>
    );
  }
  const [{ data: scenario }] = queries;

  if (!scenario)
    return (
      <>
        <div data-testid="state-klussen-empty" style={{ display: "none" }} />
        <EmptyState />
      </>
    );
  if (queries.every((q) => !q.isFetching)) prepareStore(scenario);
  return (
    <>
      <div data-testid="state-klussen-ready" style={{ display: "none" }} />
      <KlussenOverview />
    </>
  );
}
